import Resource from '@/api/resources/Resource'

class RoleOperationConfigurationServices extends Resource {
    async getRoleOperationsByRoleId(roleId) {
        const response = await this.axios.get(`/configuration/roles/${roleId}/roleOperations`)
        return response.data
    }
    async createRoleOperation(roleOperationCreateRequest) {
        const response = await this.axios.post(`/configuration/roleOperations`, roleOperationCreateRequest)
        return response.data
    }
    async deleteRoleOperation(roleOperationId) {
        const response = await this.axios.delete(`/configuration/roleOperations/${roleOperationId}`)
        return response.data
    }
}

export default new RoleOperationConfigurationServices()
